if (!customElements.get('gipsform-product-carousel')) {
  class GipsformProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gf-carousel-track]');
      this.previousButton = this.querySelector('[data-gf-carousel-prev]');
      this.nextButton = this.querySelector('[data-gf-carousel-next]');

      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.handlePrevious = () => this.move(-1);
      this.handleNext = () => this.move(1);
      this.handleScroll = () => this.updateButtons();
      this.handleResize = () => this.updateButtons();

      this.previousButton.addEventListener('click', this.handlePrevious);
      this.nextButton.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      requestAnimationFrame(() => this.updateButtons());
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.track.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    move(direction) {
      const firstCard = this.track.querySelector('.gf-related-card');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const amount = (firstCard?.getBoundingClientRect().width || this.track.clientWidth) + gap;
      this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    updateButtons() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.previousButton.disabled = this.track.scrollLeft <= 2;
      this.nextButton.disabled = this.track.scrollLeft >= maximum - 2 || maximum <= 2;
    }
  }

  customElements.define('gipsform-product-carousel', GipsformProductCarousel);
}

if (!customElements.get('gipsform-recommendations')) {
  class GipsformRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || !this.dataset.url || !this.dataset.sectionId) return;

      const separator = this.dataset.url.includes('?') ? '&' : '?';
      fetch(`${this.dataset.url}${separator}section_id=${encodeURIComponent(this.dataset.sectionId)}`)
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations request failed');
          return response.text();
        })
        .then((text) => {
          const documentFragment = new DOMParser().parseFromString(text, 'text/html');
          const renderedSection = documentFragment.querySelector('gipsform-recommendations');
          if (!renderedSection) return;
          this.innerHTML = renderedSection.innerHTML;
          this.dataset.loaded = 'true';
        })
        .catch(() => {
          this.dataset.loaded = 'true';
        });
    }
  }

  customElements.define('gipsform-recommendations', GipsformRecommendations);
}
